import { Button } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useTheme } from "@mui/material/styles";
import StandardDialog from "./StandardDialog";
import { getMFDestructiveButtonSx, getMFSecondaryButtonSx } from "../utils/dialogStyles";

const DeleteDialog = ({
  isOpen,
  instruction,
  helper,
  onAccept,
  onCancel,
  acceptedText,
}) => {
  const theme = useTheme();
  return (
    <StandardDialog
      open={isOpen}
      onClose={onCancel}
      title={instruction}
      footerLayout="center"
      footer={
        <>
          <LoadingButton
            onClick={onAccept}
            variant="contained"
            fullWidth
            sx={getMFDestructiveButtonSx(theme)}
          >
            {acceptedText}
          </LoadingButton>
          <Button
            variant="outlined"
            color="inherit"
            onClick={onCancel}
            fullWidth
            sx={getMFSecondaryButtonSx()}
          >
            Cancel
          </Button>
        </>
      }
    >
      {helper}
    </StandardDialog>
  );
};

export default DeleteDialog;
